<template>
  <div>
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/ApprovalIndex"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div class="content_title">
      <!-- <div style="margin-top: 30px; margin-bottom: 10px; text-align: left">
        <label>Task List</label>
      </div> -->
      <div
        style="
          margin-top: 30px;
          margin-bottom: 10px;
          text-align: left;
          display: flex;
        "
      >
        <label style="margin-top: 10px">Template Name</label>
        <el-input
          style="width: 300px; margin-left: 10px"
          v-model="TaskName"
          placeholder="Please input"
        ></el-input>
        <el-button
          class="button-search"
          style="margin-left: 10px"
          @click="search"
          >Search</el-button
        >
      </div>
      <div class="div-pagination">
        <el-pagination
          style="margin-left: auto"
          background
          @current-change="pagingChange"
          :current-page.sync="currentPage"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          ref="multipleTable"
        ></el-pagination>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          @current-change="handleCurrentChange"
          :data="tableData"
          :header-cell-style="tableHeaderCell"
          :cell-style="tableCell"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50px"
            style="text-align: center"
          >
          </el-table-column>
          <el-table-column
            prop="taskName"
            label="Template Name"
            min-width="400px"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="Create Time"
            min-width="200px"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="Update Time"
            min-width="200px"
          ></el-table-column>
          <el-table-column label="Edit" min-width="200px">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="padding: 0px; text-decoration: underline"
                size="small"
                @click="Edit(scope.row.id)"
                >Edit</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button class="button-s" v-if="isdisplay" @click="Create"
        >Create</el-button
      >
      <el-button class="button-s" v-if="isdisplay" @click="Delete"
        >Delete</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      loading: true,
      tableData: [],
      TaskDate: [],
      pagenum: 10,
      TaskName: "",
      multipleSelection: [],
      isdisplay: false,
      isadmin: false,
    };
  },
  methods: {
    tableHeaderCell({ column }) {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell({ column }) {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    handleSelectionChange(val) {
      var arr = [];
      if (val != null && val.length > 0) {
        val.forEach((element) => {
          arr.push(element.id);
        });
      }
      this.multipleSelection = arr;
      console.log(this.multipleSelection);
    },
    BindData(pageIndex) {
      this.$api
        .get(
          "/Task/GetTaskTemplateList/",
          {
            pageIndex,
            page: this.pagenum,
            TaskName: this.TaskName,
          },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.content;
            this.loading = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
      this.$api
        .get(
          "/Task/GetTaskTemplateCount/",
          {
            TaskName: this.TaskName,
          },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            this.total = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.BindData(1);
    },
    Edit(TaskID) {
      this.$router.push({
        name: "TaskTemplateSet",
        params: { ID: TaskID },
      });
    },
    Create() {
      this.$router.push({ path: "/TaskTemplateSet" });
    },
    Delete() {
      var IDs = this.multipleSelection.join(",");
      if (IDs != null && IDs.length > 0) {
        this.$api
          .delete("/Task/DeleteTaskTemplate", { IDs: IDs }, (res) => {})
          .then((res) => {
            if (res.data.status) {
              this.BindData(this.currentPage);
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          });
      } else {
        this.$message({
          type: "error",
          message: "Please select data",
        });
      }
    },
  },
  mounted() {
    this.$api
      .get("/Login/IsAdmin/", {}, (res) => {})
      .then((res) => {
        this.isadmin = res.data;
        this.isdisplay = res.data;
        this.BindData(1);
      });
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.el-table ::v-deep .cell,
.el-table ::v-deep th {
  padding-left: 10px;
}
.content_title {
  margin: auto;
  width: 90%;
  text-align: center;
  margin-top: 10px;
}
.el-button--text {
  color: #606266;
}
.div-pagination {
  text-align: right;
  margin-bottom: 10px;
  display: flex;
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
  margin-bottom: 20px;
}
.button-s {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>
<style>
.el-table .cell,
.el-table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/TaskTemplate.vue